/**
 * Checks for Akamai self-hosted script for AMP platform
 * If it doesn't exist, creates and attaches it to head
 */

/* eslint-disable import/prefer-default-export */
export const attachPlatformScript = () => new Promise((resolve) => {
	const ampScriptID = document.getElementById('ampScript');
	const ampScript = ampScriptID || document.createElement('script');

	// Create script element if not present & loads the script
	if (!ampScriptID) {
		ampScript.addEventListener('load', function _listener() {
			ampScript.removeEventListener('load', _listener);
			resolve(ampScript);
		});
		ampScript.setAttribute('id', 'ampScript');
		ampScript.setAttribute('src', 'https://amp.akamaized.net/hosted/1.1/player.esi?apikey=webmd.prod&version=9.1.32');
		ampScript.setAttribute('async', 'async');
		document.head.appendChild(ampScript);
	} else if (ampScript.readyState === 'complete' || window.akamai) {
		// If the script is already loaded and has state 'complete', resolve the promise immediately.
		resolve(ampScript);
	} else {
		// If the script is already loaded but not in 'complete' state, wait for the 'load' event.
		ampScript.addEventListener('load', function _listener() {
			ampScript.removeEventListener('load', _listener);
			resolve(ampScript);
		});
	}
});
